import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Hero from './components/Hero';
import AudienceSection from './components/AudienceSection';
import AudienceTabsSection from './components/AudienceTabsSection';
import StrategySection from './components/StrategySection';
import { PageBackground } from './components/CowPattern';
import FrankenbusinessSection from './components/FrankenbusinessSection';
import ToolsSection from './components/ToolsSection';
import StrategyZonesSection from './components/StrategyZonesSection';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <PageBackground />
      <Header />
      <main>
        <Hero />
        <AudienceSection />
        <StrategySection />
        <FrankenbusinessSection />
        <StrategyZonesSection />
        <AudienceTabsSection />
        <ToolsSection />
      </main>
    </ThemeProvider>
  );
}

export default App;
